/* =============================================================
   MINIALPPACA — Theme JS (global)
   Inclui: header com sombra ao rolar e atualização do contador
   do carrinho via evento `cart:updated`.
   Carregado em todas as páginas pelo theme.liquid (defer).
============================================================= */

(function () {
  'use strict';

  // Premium page entrance — fade body in once first paint is ready
  function markLoaded() {
    document.body.classList.add('is-loaded');
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    requestAnimationFrame(function () { requestAnimationFrame(markLoaded); });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(function () { requestAnimationFrame(markLoaded); });
    });
  }
  // Safety fallback in case something blocks the entrance
  setTimeout(markLoaded, 1500);

  // Header sticky shadow on scroll
  var header = document.getElementById('SiteHeader');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('scrolled', window.scrollY > 40);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Update cart count nodes when add-to-cart succeeds
  document.addEventListener('cart:updated', function (e) {
    if (!e || !e.detail) return;
    var count = (typeof e.detail.item_count === 'number') ? e.detail.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  });
})();
